
// 21.03 error message etc oncesi

import React, { useEffect, useState } from "react";
import "../../styles/Common.css";
import axios from "axios";
import config from '../../config/config';
import { useTenant } from "../../context/TenantContext";

const ProcessSelection = ({ process, onChange, label, folder, error: errorProp, disabledProcess }) => {
  const { selectedTenant } = useTenant();
  const [processes, setProcesses] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (!folder || !selectedTenant) {
      setProcesses([]);
      setError("");
      return;
    }

    const fetchProcesses = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("userToken");

        if (!token) {
          setError("User token is missing. Please log in again.");
          setProcesses([]);
          return;
        }

        const response = await axios.get(
          `${config.API_BASE_URL}/api/orchestrator/releases/${folder}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              'selected-tenant': JSON.stringify(selectedTenant),
              'X-UIPATH-OrganizationUnitId': selectedTenant.orch_tenant_id.toString()
            }
          }
        );

        // Update to handle the correct response structure
        if (response.data && Array.isArray(response.data.releases)) {
          setProcesses(response.data.releases.map(proc => ({
            id: proc.Key,
            name: proc.ProcessKey,
            version: proc.ProcessVersion
          })));
          setError("");
        } else {
          console.warn("Unexpected process data format:", response.data);
          setError("No processes available in this folder");
          setProcesses([]);
        }
      } catch (error) {
        console.error("Process fetch error:", error);
        setError("Failed to fetch processes. Please check your folder.");
        setProcesses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProcesses();
  }, [folder, selectedTenant]);

  // Remove or fix the isDisabled line since 'disabled' is not defined
  // const isDisabled = disabled || !folder || error;

  return (
    <div className="form-group">
      <label>Select Process * </label>
      <select 
        value={process?.id || ""}
        onChange={(e) => {
          const selected = processes.find(p => p.id === e.target.value);
          onChange(selected || null);
        }}
        disabled={!folder || loading || Boolean(error)}
      >
        {!folder ? (
          <option value="">Please select folder first</option>
        ) : loading ? (
          <option value="">Loading processes...</option>
        ) : error ? (
          <option value="">{error}</option>
        ) : (
          <>
            <option value="">Select a process</option>
            {processes.map((proc) => (
              <option 
                key={proc.id} 
                value={proc.id}
                disabled={proc.id === disabledProcess}
                style={proc.id === disabledProcess ? { color: 'gray', backgroundColor: '#f0f0f0' } : {}}
              >
                {proc.name}
              </option>
            ))}
          </>
        )}
      </select>
      {errorProp && <span className="error-message">{errorProp}</span>}
    </div>
  );
};

export default ProcessSelection;
